/* ============================================================
   CTA BEG KUNING — simpanan template + pilihan per-browser
   ============================================================
   "CTA beg kuning" = teks pada BUTANG pautan produk TikTok (beg
   kuning). Ia BUKAN ayat penutup caption — itu benda lain, dan
   petak PRO Studio yang sama akan memegangnya kemudian.

   ⛔ DUA JENIS SIMPANAN, SENGAJA BERASINGAN — jangan gabungkan:

   1. SENARAI TEMPLATE → Firestore, milik AKAUN.
      `users/{uid}/ctaTemplates/{id}`. Pelanggan urus di PRO Studio;
      ia sama di semua browser dia.

      ⚠️ Ia collection BERASINGAN, bukan medan dalam doc `users`.
      Doc `users` ada had keras 1 MB, dan pada 2026-08-31 lima akaun
      pelanggan berada dalam 21–65 KB daripada had itu (yang teruk
      tinggal 21 BAIT). Menambah senarai ke dalam doc itu boleh
      memecahkan akaun mereka sepenuhnya — SEMUA tulisan gagal,
      termasuk kaunter kuota harian. Medan warisan sudah dibersihkan
      sejak itu, tetapi peraturannya kekal: data yang boleh membesar
      TIDAK masuk ke dalam doc `users`.

   2. PILIHAN "guna yang mana" → localStorage, milik BROWSER INI.
      Pelanggan guna 3–5 browser serentak untuk kerja selari. Semua
      tetapan larian ikut corak per-browser sejak 2026-08-25 — kalau
      CTA tidak ikut, menukar CTA di satu browser akan menukar CTA
      larian browser lain yang SEDANG berjalan.
   ============================================================ */

import { collection, doc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebase';

export const CTA_COL = 'ctaTemplates';

/* Had 50 aksara — keputusan user 2026-09-04. Dikuatkuasakan di SINI dan
   sekali lagi dalam skrip automation. Dua tempat bukan pertindihan sia-sia:
   nilai yang tersimpan sebelum had ini wujud boleh lebih panjang, dan
   skrip itulah yang benar-benar menaip ke dalam TikTok. */
export const CTA_MAX = 50;

/* Teks lalai bila pelanggan tidak memilih apa-apa. ⚠️ Ini SALINAN untuk
   dipaparkan sahaja — yang benar-benar dipakai ialah jatuh-balik dalam
   skrip automation. Sengaja begitu: pelanggan pada extension lama tidak
   menerima kotak `tetapan` langsung, jadi jatuh-balik WAJIB hidup di
   hujung sana, bukan di sini. */
export const CTA_LALAI = 'BELI KAT SINI';

export const bersihkanCta = (teks) => String(teks ?? '').replace(/\s+/g, ' ').trim().slice(0, CTA_MAX);

/* Susunan paparan: ikut `order`, kemudian abjad. Satu pembanding supaya
   PRO Studio dan dropdown Control Panel mustahil terpesong. */
export const bandingCta = (a, b) => {
    const oa = Number.isFinite(a?.order) ? a.order : 9e9;
    const ob = Number.isFinite(b?.order) ? b.order : 9e9;
    if (oa !== ob) return oa - ob;
    return String(a?.teks || '').localeCompare(String(b?.teks || ''));
};

export async function simpanCta({ id, teks, order }) {
    const uid = auth.currentUser?.uid;
    if (!uid) throw new Error('Belum log masuk');
    const bersih = bersihkanCta(teks);
    if (!bersih) throw new Error('kosong');
    const idAkhir = id || `cta_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const rujukan = doc(collection(db, 'users', uid, CTA_COL), idAkhir);
    const muatan = { id: idAkhir, teks: bersih, updatedAt: serverTimestamp() };
    if (Number.isFinite(order)) muatan.order = order;
    if (!id) muatan.createdAt = serverTimestamp();
    /* merge — supaya menyunting teks tidak memadam `order`/`createdAt`. */
    await setDoc(rujukan, muatan, { merge: true });
    return idAkhir;
}

export async function padamCta(id) {
    const uid = auth.currentUser?.uid;
    if (!uid || !id) return;
    await deleteDoc(doc(db, 'users', uid, CTA_COL, id));
}

/* ── Pilihan per-browser ────────────────────────────────────── */
const KUNCI_PILIHAN = 'sesaat_cta_pilihan_v1';

export const bacaCtaPilihan = () => {
    try { return localStorage.getItem(KUNCI_PILIHAN) || ''; } catch { return ''; }
};

/* ⛔ Panggil ini HANYA daripada tindakan pengguna (onChange), JANGAN
   daripada useEffect. Effect turut berjalan pada mount, jadi setiap browser
   akan menyimpan nilai lalai walaupun penggunanya tidak pernah memilih —
   dan selepas itu menukar nilai lalai langsung tidak berkesan. Perangkap
   yang sama pernah berlaku pada `sesaat_products_paparan_v2` dan pada
   kotak "Isi" jadual. */
export const tulisCtaPilihan = (id) => {
    try {
        if (id) localStorage.setItem(KUNCI_PILIHAN, id);
        else localStorage.removeItem(KUNCI_PILIHAN);
    } catch { /* storan penuh / mod privasi — abaikan */ }
};

/* Tukar pilihan (id) → teks yang benar-benar dihantar ke robot.

   ⚠️ Diselesaikan pada masa RUN daripada senarai HIDUP, bukan disimpan
   sebagai teks. Sebabnya: kalau teks disimpan, menyunting template di
   PRO Studio tidak akan mengubah larian; dan kalau template DIPADAM,
   pilihan menjadi tergantung. Di sini, template yang hilang memulangkan
   '' → skrip automation jatuh ke lalai. Senyap, tetapi selamat — dan
   skrin PRO Studio/Control Panel yang memberitahu pelanggan. */
export const ctaTeksUntukLarian = (senarai, idPilihan) => {
    if (!idPilihan) return '';
    const jumpa = (senarai || []).find((x) => x.id === idPilihan);
    return jumpa ? bersihkanCta(jumpa.teks) : '';
};
